import { ICapabilityModelDefinition } from 'src/app/shared/interfaces/capability-model-definition';

export class GetDcmMenu {
    public static readonly type = '[Asset] Get Dcm Menu';

    constructor(public roleMenu: string) {}
}

export class SetCapabilityModel {
    public static readonly type = '[Asset] Set Capability Model';

    constructor(public capabilityModelDefinition: ICapabilityModelDefinition) {}
}

export class SetCapabilityModelUi {
    public static readonly type = '[Asset] Set Capability Model UI';

    constructor(public uiDcm: unknown) {}
}
